import template from "./upload.html";
import './upload.styl';

class UploadController {
	constructor($upload, $element) {
		"ngInject";
		this.$upload = $upload;
		this.$element = $element;
		this.id = Math.random().toString(36).substring(7);
		this.uploading = false;
	}

	$onSubmit($event) {
		this.uploading = true;
		this.$upload
			.upload(this.uri, $event.target[0].files[0])
			.then((attachment) => this.model = attachment)
			.then(() => this.uploading = false)
			.then(() => this.callback())
			.then(() => this.$element.find("input")[0].value = null);
	}
}

export const UploadComponent = {
	template,
	controller: UploadController,
	controllerAs: "upload",
	bindings: {
		callback: "&",
		customString: "@",
		uri: "<",
		model: "="
	}
};


/** WEBPACK FOOTER **
 ** ./frontend/components/utility/upload/upload.component.js
 **/